import { render, staticRenderFns } from "./user_cert_list.vue?vue&type=template&id=1f3fa3c1&scoped=true&"
import script from "./user_cert_list.vue?vue&type=script&lang=js&"
export * from "./user_cert_list.vue?vue&type=script&lang=js&"
import style0 from "./user_cert_list.vue?vue&type=style&index=0&id=1f3fa3c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3fa3c1",
  null
  
)

export default component.exports